import React from 'react';
import { Box } from '@mui/material';
import { DataGridContainer } from './styled';
import { ScoringType } from './types/scoringType';
import { getScoringTypeColumns } from './utils/scoringTypeColumns';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../layouts/pallet';
import { dataGridSx } from '../common/styled/DataGrid';

interface ScoringTypesTableProps {
  onEdit: (scoringType: ScoringType) => void;
  onDelete: (scoringType: ScoringType) => void;
  scoringTypes: ScoringType[];
  isLoading: boolean;
}

const ScoringTypesTable: React.FC<ScoringTypesTableProps> = ({
  onEdit,
  onDelete,
  scoringTypes,
  isLoading
}) => {
  const columns = getScoringTypeColumns(onEdit, onDelete);

  return (
    <DataGridContainer>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rowHeight={50}
          rows={scoringTypes}
          columns={columns}
          loading={isLoading}
          disableRowSelectionOnClick
          pageSizeOptions={[5, 10, 25]}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            },
            columns: {
              ...columns,
              columnVisibilityModel: { id: false }
            }
          }}
          sx={{
            ...dataGridSx(pallet),

            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto'
            }
          }}
        ></DataGrid>
      </Box>
    </DataGridContainer>
  );
};

export default ScoringTypesTable;
